import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { ISeguimientoProyecto, ISeguimientoProyectoSolicitud } from 'src/app/interface/interfaces';
import { SenaceService } from 'src/app/services/senace.service';
import { environment } from "src/environments/environment";

const urlDocById = environment.apiUrlDownloadById;

@Component({
  selector: 'app-seguimiento',
  templateUrl: './seguimiento.component.html',
  styleUrls: ['./seguimiento.component.css']
})
export class SeguimientoComponent implements OnInit {
  estudio: ISeguimientoProyecto = {};
  seguimientos: ISeguimientoProyectoSolicitud[] = [];
  urlDocById  = urlDocById;

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) {
    this.localStorage.getItem('detalle').subscribe(
      resp => {
        this.setEstudio(resp);
        this.setSeguimiento(resp);
      });
  }

  ngOnInit() {

  }

  setEstudio(respuesta) {
    this.estudio.titular = respuesta.empresa;
    this.estudio.proyecto = respuesta.asunto;
    this.estudio.codigoTupa = respuesta.correlativo;
    this.estudio.tipoEstudio = respuesta.tipoEstudio;
    this.estudio.estadoProyecto = respuesta.estado;

    this.estudio.expediente = respuesta.correlativo
    this.estudio.fechaPresentacion = respuesta.fechaRegistro
  }

  setSeguimiento(respuesta) {
    this.seguimientos.push({ fecha: respuesta.fechaInicio, estadoSolicitud: 'Enviado a Senace' });
    // Autodirectorial
    let documento: string;
    if (respuesta.autoDirectorial) {
      if (respuesta.autoDirectorial.nombre && respuesta.autoDirectorial.docId) {
        documento = respuesta.autoDirectorial.docId;
      }
    }

    if (respuesta.informeTecnicoFinal) {
      if (respuesta.informeTecnicoFinal.nombre && respuesta.informeTecnicoFinal.docId) {
        documento = respuesta.informeTecnicoFinal.docId;
      }
    }

    this.seguimientos.push({ fecha: respuesta.solicitud.fechaAlta, estadoSolicitud: respuesta.solicitud.estadoSolicitud, documento: documento });
  }

}
